// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2dNzP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__5OoUz"};